import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './todoConfig'

import { framework_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
class PorcTaskTodo extends WizContainer {

  componentName = 'PorcTaskTodo';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _audit(id){
    alert(id);
  }


  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig,
      apiDataFormat: {
        updateSuspensionState:this._handleCMD
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(PorcTaskTodo);
